import { render } from "./OapImmersiveCopyOnVideo.vue?vue&type=template&id=3b68e88a"
import script from "./OapImmersiveCopyOnVideo.vue?vue&type=script&lang=js"
export * from "./OapImmersiveCopyOnVideo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__